export class EmailAccount{
  ID: number;
  username?: string;
  password?: string;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/EmailAccount.ts